"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDriver = findDriver;
exports.checkDriverSupport = checkDriverSupport;
exports.checkDriverSwitchRestrictions = checkDriverSwitchRestrictions;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const Playback = tslib_1.__importStar(require("../controls/playback"));
/**
 * Finds the driver in the provided options array.
 */
function findDriver(klass, options) {
    const [priority, driver] = options.reduce((acc, driver, idx) => {
        if (driver.id === klass.driverName) {
            return [idx, driver];
        }
        return [acc[0], acc[1]];
    }, [-1, null]);
    return [options.length - priority, driver];
}
function checkDriverSupport(klass, host, manifest) {
    return (klass.isHostSupported(host) ? "h" : "")
        + (klass.isManifestSupported(manifest) ? "m" : "")
        + (klass.isPlatformSupported() ? "p" : "");
}
function checkDriverSwitchRestrictions(groups) {
    if ((0, state_flow_1.isTransitioning)(groups.playback)) {
        return state_flow_1.Result.reject("playing state is in transition");
    }
    if (Playback.Playing.is(groups.playback)) {
        return state_flow_1.Result.reject("driver is in playing state");
    }
    return state_flow_1.Result.ignore();
}
//# sourceMappingURL=common.js.map